var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "table-wrapper",
    [
      _c("v-data-table", {
        attrs: {
          headers: _vm.headers,
          items: _vm.items,
          loading: _vm.loading,
          "loading-text": "Loading your mailboxes…",
          "item-key": "id",
          "sort-by": "email",
          "footer-props": _vm.footerProps
        },
        scopedSlots: _vm._u([
          {
            key: "item.email",
            fn: function fn(_ref) {
              var item = _ref.item
              return [
                _c(
                  "span",
                  {
                    staticClass: "font-weight-medium"
                  },
                  [_vm._v(_vm._s(item.email))]
                )
              ]
            }
          },
          {
            key: "item.storage",
            fn: function fn(_ref2) {
              var item = _ref2.item
              return [
                _c(
                  "div",
                  {
                    staticClass: "font-weight-medium"
                  },
                  [
                    _vm._v(
                      _vm._s(
                        item.unlimited
                          ? "Unlimited"
                          : "".concat(
                              _vm.quotaPercentage(item.diskusedpercent_float),
                              "%"
                            )
                      )
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass: "text-no-wrap text--secondary"
                  },
                  [
                    _vm._v(
                      " " +
                        _vm._s(item.humandiskused) +
                        " / " +
                        _vm._s(item.unlimited ? "∞" : item.humandiskquota) +
                        " "
                    )
                  ]
                )
              ]
            }
          },
          {
            key: "item.status",
            fn: function fn(_ref3) {
              var item = _ref3.item
              return [
                _c(
                  "v-icon",
                  {
                    staticClass: "pb-1",
                    attrs: {
                      small: "",
                      color: _vm.statusColor(item.status),
                      "aria-hidden": "true"
                    }
                  },
                  [_vm._v("mdi-circle")]
                ),
                _vm._v(" " + _vm._s(item.status) + " ")
              ]
            }
          },
          {
            key: "item.actions",
            fn: function fn(_ref4) {
              var item = _ref4.item
              return [
                _c(
                  "div",
                  {
                    staticClass: "d-flex align-center justify-end"
                  },
                  [
                    _c(
                      "gg-btn",
                      {
                        staticClass: "mr-2 text-no-wrap",
                        attrs: {
                          secondary: "",
                          small: "",
                          "aria-label": "Open webmail for ".concat(item.email)
                        },
                        on: {
                          click: function click($event) {
                            return _vm.$emit("action", {
                              action: "webmail",
                              mailbox: item
                            })
                          }
                        }
                      },
                      [
                        _vm._v(" Webmail "),
                        _c(
                          "v-icon",
                          {
                            staticClass: "ml-1",
                            attrs: {
                              small: "",
                              "aria-hidden": "true"
                            }
                          },
                          [_vm._v("mdi-open-in-new")]
                        )
                      ],
                      1
                    ),
                    _c("mailbox-actions-menu", {
                      attrs: {
                        mailbox: item
                      },
                      on: {
                        action: function action($event) {
                          return _vm.$emit("action", $event)
                        }
                      }
                    })
                  ],
                  1
                )
              ]
            }
          },
          {
            key: "no-data",
            fn: function fn() {
              return [
                _c(
                  "div",
                  {
                    staticClass: "py-8 text-center"
                  },
                  [
                    _vm.filtered
                      ? [
                          _c(
                            "p",
                            {
                              staticClass: "mb-2 font-weight-medium"
                            },
                            [_vm._v("No mailboxes match your filters.")]
                          ),
                          _c(
                            "gg-btn",
                            {
                              attrs: {
                                small: "",
                                tertiary: ""
                              },
                              on: {
                                click: function click($event) {
                                  return _vm.$emit("clear-filters")
                                }
                              }
                            },
                            [_vm._v("Clear filters")]
                          )
                        ]
                      : [
                          _c(
                            "p",
                            {
                              staticClass: "mb-2 font-weight-medium"
                            },
                            [
                              _vm._v(
                                "This account doesn't have any mailboxes yet."
                              )
                            ]
                          ),
                          _c(
                            "p",
                            {
                              staticClass: "mb-0"
                            },
                            [
                              _vm._v(
                                "Use Add Mailbox above to add the first one."
                              )
                            ]
                          )
                        ]
                  ],
                  2
                )
              ]
            },
            proxy: true
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }